'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _class, _class2, _temp;

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactBootstrap = require('react-bootstrap');

var _reactRouter = require('react-router');

var _reduxAsyncConnect = require('redux-async-connect');

var _config = require('./../../config');

var _config2 = _interopRequireDefault(_config);

var _auth = require('redux/modules/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var footerLogoImage = require('./logo-footer.png');
var copyrightImage = require('./by-nc-nd.png');
var styles = require('./App.scss');

var App = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;


    if (!(0, _auth.isAuthLoaded)(getState())) {
      return dispatch((0, _auth.loadAuth)());
    }
    return _promise2.default.resolve();
  }
}]), _dec(_class = (0, _reactIntl.injectIntl)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'render',
    value: function render() {
      var formatMessage = this.props.intl.formatMessage;

      var navTitle = _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'icon-globe shifted' }),
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'language' })
      );

      return _react2.default.createElement(
        'div',
        { className: styles.app },
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(
          _reactBootstrap.Navbar,
          { fixedTop: true },
          _react2.default.createElement(
            _reactBootstrap.Navbar.Header,
            null,
            _react2.default.createElement(
              _reactBootstrap.Navbar.Brand,
              null,
              _react2.default.createElement(
                _reactRouter.IndexLink,
                { to: '/' },
                _react2.default.createElement('span', { className: styles.brand }),
                _react2.default.createElement(
                  'span',
                  { className: styles.brandText },
                  formatMessage({ id: 'dharma-treasure' })
                )
              )
            ),
            _react2.default.createElement(_reactBootstrap.Navbar.Toggle, null)
          ),
          _react2.default.createElement(
            _reactBootstrap.Navbar.Collapse,
            null,
            _react2.default.createElement(
              _reactBootstrap.Nav,
              { navbar: true, pullRight: true },
              _react2.default.createElement(
                _reactBootstrap.NavDropdown,
                { id: 'dropdown-lang', bsStyle: 'link', title: navTitle },
                _react2.default.createElement(
                  _reactBootstrap.MenuItem,
                  { href: '?locale=en' },
                  'English'
                ),
                _react2.default.createElement(
                  _reactBootstrap.MenuItem,
                  { href: '?locale=bo' },
                  '\u0F56\u0F7C\u0F51\u0F0B\u0F66\u0F90\u0F51\u0F0D'
                ),
                _react2.default.createElement(
                  _reactBootstrap.MenuItem,
                  { href: '?locale=zh-TW' },
                  '\u7E41\u9AD4\u4E2D\u6587'
                ),
                _react2.default.createElement(
                  _reactBootstrap.MenuItem,
                  { href: '?locale=zh-CN' },
                  '\u7B80\u4F53\u4E2D\u6587'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.appContent },
          this.props.children
        ),
        _react2.default.createElement(
          'footer',
          null,
          _react2.default.createElement(
            'nav',
            null,
            _react2.default.createElement(
              'div',
              { className: styles.footerNav },
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'http://dharma-treasure.org/' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dharma-treasure-official-website' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'https://adarsha.dharma-treasure.org' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'adarsha' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'http://dharmaebooks.org/' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dharma-ebooks' })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'section',
            null,
            _react2.default.createElement(
              'div',
              { className: '' + styles.footerSection },
              _react2.default.createElement(
                'div',
                { className: styles.footerContent + ' container clearfix' },
                _react2.default.createElement(
                  'div',
                  { className: '' + styles.footerRow },
                  _react2.default.createElement(
                    'div',
                    { className: '' + styles.footerLogo },
                    _react2.default.createElement('img', { src: footerLogoImage, alt: 'footer logo image' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: '' + styles.footerContact },
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'email' }),
                        _react2.default.createElement(
                          'span',
                          null,
                          ': support@dharma-treasure.org'
                        )
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'phone' }),
                        _react2.default.createElement(
                          'span',
                          null,
                          ': 02-27586828'
                        )
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'address' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'address-content' })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-fw fa-at' }),
                        _react2.default.createElement(
                          'span',
                          { className: 'copyright' },
                          '2018 Dharma Treasure Corp. Copyright.'
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.footerCompany },
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'a',
                    { href: formatMessage({ id: 'copyright-link' }) },
                    _react2.default.createElement('img', { src: copyrightImage, alt: 'Creative Commons', width: '100', height: '35' })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return App;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.object.isRequired,
  intl: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App/App.js
 ** module id = 1235
 ** module chunks = 0
 **/